var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: false, expression: "false" },
      ],
    },
    [
      _c("DetailsModal", {
        ref: "detailsModal",
        attrs: { processes: _vm.processes, clients: _vm.clients },
        on: {
          closed: _vm.onDetailsModalClosed,
          hidden: _vm.onDetailsModalHidden,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }